<modal class="modal-window password-recovery"
  [ngClass]="{
    'password-recovery': !fullScreen,
    'password-recovery-mobile': fullScreen
  }"
  [name]="localStorageKeys.ti_modal_password_recovery_setup"
  height="{{fullScreen ? '100%' : '325px'}}"
  width="{{fullScreen ? '100%' : '500px'}}"
  [ignoreEscKey]="true"
>
  <modal-header [noCloseButton]="true">
    <span>{{ strings.title }}</span>
  </modal-header>

  <modal-body>
    <div class="text-danger">
      {{ strings.youMustComplete }}
    </div>
    <br>
    <div>
      {{ strings.selectSecretQuestionsAndAnswers }}
    </div>
    <br>
    <div *ngIf="questionsList && answeredList">
      <ti-reset-password-questions-answers
        [firstSubmit]="firstSubmit"
        [questionsCount]="questionsCount"
        [questionsList]="questionsList"
        [answeredList]="answeredList"
        [answersMasked]="true"
        ngModel
        [name]="QUESTIONS_ANSWERS_FIELD"
        #questionsAnswers="ngModel"
        required
      >
      </ti-reset-password-questions-answers>
    </div>

  </modal-body>

  <modal-actions>
    <button kendoButton [primary]="true" (click)="save()"> {{ miscStrings.save }}</button>
  </modal-actions>
</modal>


